module.exports = __webpack_public_path__ + "static/img/hair_07.928bd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/hair_07.png
// module id = dEDt
// module chunks = 0